import { IPromotionModel, PageType, TrackingRequest } from "@/models";
import { getFacebookCookieValue } from "@/helpers";

/**
 * Gets a page visit request for POST api/Tracking/visit
 * @param promotion the promotion
 * @param page the page
 * @param currentUrl the URL of the event
 */

export function getVisitTrackingRequest(
    promotion: IPromotionModel,
    page: PageType,
    currentUrl: string
): TrackingRequest {
    return {
        type: "visit",
        tracking: {
            promotionId: promotion.id,
            pageTypeId: page,
            promotionCode: promotion.promotionCode,
            campaignCode: promotion.campaignCode,
            facebookFbpCookieValue: getFacebookCookieValue("_fbp"),
            facebookFbcCookieValue: getFacebookCookieValue("_fbc"),
            eventSourceUrl: currentUrl
        }
    };
}
